import { render, staticRenderFns } from "./TheFormRegister.vue?vue&type=template&id=def194be&scoped=true&"
import script from "./TheFormRegister.vue?vue&type=script&lang=ts&"
export * from "./TheFormRegister.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def194be",
  null
  
)

export default component.exports